module.exports = __webpack_public_path__ + "img/location-dot-sharp-light-normal.e0206522.svg";